import { Button, TableCell } from '@mui/material';
import styled from 'styled-components';

export const ActionsTableCell = styled(TableCell)`
    white-space: nowrap;

    padding: 0.2rem 1rem;
`;

export const StyledActionButton = styled(Button)`
    margin-right: 0.2rem;

    &:last-child {
        margin-right: 0;
    }
`;

export const StyledTableCell = styled(TableCell)`
    padding: 0 1rem;
`;
